import { some } from 'lodash';

export default function isFeePerBookingProvider(provider) {
    /*eslint-disable*/
    /*
    temporarily returning true regardless of isFeePerBooking for
    testing purposes. Will be reverted after testing finishes
    */
    return true;
    return some(provider.practices, ['isFeePerBooking', true]);
}
